export type LicenseFieldSource = {
  officialLicenseNumber?: string | null;
  licenseValidFrom?: string | null;
  licenseValidTo?: string | null;
};

export type LicenseDateFields = {
  officialNumber: string;
  validFrom: string;
  validTo: string;
};

export type LicenseFormFields = LicenseDateFields & {
  holderName: string;
};

export function serverLicenseFields(
  detail: LicenseFieldSource | null | undefined
): LicenseDateFields {
  return {
    officialNumber: detail?.officialLicenseNumber?.trim() || '',
    validFrom: detail?.licenseValidFrom?.slice(0, 10) || '',
    validTo: detail?.licenseValidTo?.slice(0, 10) || '',
  };
}

/**
 * Si el operador ya editó nº o vigencia, una recarga del pedido (sustituir PDF,
 * volver a la ficha) no pisa lo escrito hasta que el servidor devuelva esos valores.
 */
export function keepEditedLicenseFields(
  local: LicenseDateFields,
  server: LicenseDateFields,
  dirty: boolean
): { fields: LicenseDateFields; dirty: boolean } {
  if (!dirty) return { fields: { ...server }, dirty: false };
  const caughtUp =
    local.officialNumber.trim() === server.officialNumber &&
    local.validFrom === server.validFrom &&
    local.validTo === server.validTo;
  if (caughtUp) return { fields: { ...server }, dirty: false };
  return { fields: { ...local }, dirty: true };
}

export function licenseMetadataBody(fields: LicenseFormFields): {
  officialLicenseNumber?: string;
  holderName?: string;
  licenseValidFrom?: string;
  licenseValidTo?: string;
} {
  const officialLicenseNumber = fields.officialNumber.trim();
  const holderName = fields.holderName.trim();
  return {
    ...(officialLicenseNumber ? { officialLicenseNumber } : {}),
    ...(holderName ? { holderName } : {}),
    ...(fields.validFrom ? { licenseValidFrom: fields.validFrom } : {}),
    ...(fields.validTo ? { licenseValidTo: fields.validTo } : {}),
  };
}

export function licenseValidityLabel(from?: string | null, to?: string | null): string | null {
  const start = from?.slice(0, 10) || '';
  const end = to?.slice(0, 10) || '';
  if (!start && !end) return null;
  return `${start || '—'} → ${end || '—'}`;
}

const SAVED_BEFORE_REFUSAL = [
  'No se puede entregar sin licencia definitiva (PDF)',
  'No se puede entregar sin correo del destinatario',
  'No se puede entregar sin fechas de validez de la licencia',
];

/** Esos 400 salen después de haber grabado nº, titular y vigencia. */
export function deliverSavedBeforeRefusal(message: string): boolean {
  return SAVED_BEFORE_REFUSAL.some((item) => message.includes(item));
}
